import { environment as qaEnvironment } from './environment.qa';

export const environment = {
  ...qaEnvironment,
  name: 'arkai',
  production: false,
  webApiRoot: ''
};

